import {ReportRequestParametersObjectObject} from 'common/api/api.ts'
import {CommonRoutes} from 'common/context/commonRoutes.ts'
import Report from 'common/pages/report/Container.tsx'
import {FormMode} from 'common/util/Util.tsx'

export const TrackerEventStatsAgency = () => (
  <Report
    mode={FormMode.create}
    reportType={ReportRequestParametersObjectObject.TypeEnum.Tracker}
    savedReportBaseRoute={CommonRoutes.TRACKER_EVENT_REPORT}
    title="New Tracker Report"
  />
)
